import * as PIXI from "pixi.js";

export const initializePixiApp = (
  container: HTMLDivElement,
  applicationOptions?: PIXI.IApplicationOptions
) => {
  const app = new PIXI.Application({
    backgroundColor: 0, // Doesn't matter
    antialias: true,
    resizeTo: container,
    resolution: window.devicePixelRatio,
    autoDensity: true,
    // backgroundAlpha: 0,
    ...applicationOptions
  });

  container.replaceChildren(app.view as unknown as Node);

  return app;
};
